import React, { useState } from 'react';
import { Box, Container, Typography, Tabs, Tab } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import '@fontsource/roboto';
import '@fontsource/merriweather';

// Import reusable components
// import SquadAnnouncement from '../components/tournaments/SquadAnnouncement';
// import GroupDraw from '../components/tournaments/GroupDraw';
// import MatchFixtures from '../components/tournaments/MatchFixtures';
// import FanSupport from '../components/tournaments/FanSupport';
import ComingSoon from '../components/tournaments/ComingSoon';

// Import data
import {
  tournaments,
  // squadPlayersHimalayan,
  // squadPlayersGurkha,
  // squadPlayersGurkhaVeteran,
  // himalayanCupData,
} from '../components/tournaments/tournamentData';

const Tournaments = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // const renderHimalayanCupContent = () => (
  //   <>
  //     <SquadAnnouncement
  //       title="Squad Announcement"
  //       players={squadPlayersHimalayan}
  //       coachName="MABIN RAI"
  //       backgroundImage="/players/idea_1.JPG"
  //     />

  //     <GroupDraw
  //       groupName="Group B"
  //       teams={himalayanCupData.groupTeams}
  //       tournamentDate={himalayanCupData.tournamentDate}
  //       tournamentName={himalayanCupData.tournamentName}
  //     />

  //     <MatchFixtures
  //       title="Match Fixtures"
  //       subtitle="HIMALAYAN CUP TOURNAMENT 2025"
  //       fixtures={himalayanCupData.fixtures}
  //       footerMessage="Come support our team through all three matches! ⚽🔥"
  //     />

  //     <FanSupport
  //       title="Come Support Our Team!"
  //       message={`Join us at the Himalayan Cup Football Tournament on ${himalayanCupData.tournamentDate} and cheer for Mirmire SC as we compete for glory!`}
  //       footerMessage="Your support means everything to our players. Let's make some noise! 📣⚽"
  //     />
  //   </>
  // );

  // const renderGurkhaCupAnnouncement = () => (
  //   <>
  //     <SquadAnnouncement
  //       title="Squad Announcement"
  //       players={squadPlayersGurkha}
  //       coachName="MABIN RAI"
  //       backgroundImage="/players/MSC_0324.JPG"
  //     />

  //     <SquadAnnouncement
  //       title="Veteran Squad Announcement"
  //       players={squadPlayersGurkhaVeteran}
  //       coachName="Samir Koirala"
  //       backgroundImage="/gallery/MSC_0330.JPG"
  //       isVeteran={true}
  //     />
  //   </>
  // );

  const renderComingSoonContent = tournamentName => (
    <ComingSoon
      tournamentName={tournamentName}
      title="To Be Announced"
      message="Stay tuned for updates on our participation in this tournament."
      footerMessage="More details when tournament information is available! 🏆"
    />
  );

  return (
    <>
      <Helmet>
        <title>Tournaments - Mirmire</title>
        <meta
          name="description"
          content="Mirmire SC tournament information and participation details"
        />
      </Helmet>

      {/* Page Header */}
      <Box
        sx={{
          bgcolor: '#000000',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: '#FFD700',
            fontWeight: 700,
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            textAlign: 'center',
            fontFamily: 'Merriweather, serif',
          }}
        >
          TOURNAMENTS
        </Typography>
      </Box>

      {/* Tournament Tabs */}
      <Box
        sx={{
          bgcolor: '#000000',
          borderBottom: '2px solid #FFD700',
        }}
      >
        <Container maxWidth="lg">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              '& .MuiTabs-indicator': {
                backgroundColor: '#FFD700',
                height: 3,
              },
              '& .MuiTabs-scroller': {
                display: 'flex',
                justifyContent: { xs: 'flex-start', md: 'center' },
              },
              '& .MuiTabs-flexContainer': {
                justifyContent: { xs: 'flex-start', md: 'center' },
              },
              '& .MuiTab-root': {
                color: '#FFFFFF',
                fontFamily: 'Merriweather, serif',
                fontWeight: 600,
                fontSize: { xs: '0.8rem', md: '1rem' },
                textTransform: 'uppercase',
                letterSpacing: '1px',
                minWidth: { xs: 100, md: 140 },
                '&.Mui-selected': {
                  color: '#FFD700',
                },
                '&:hover': {
                  color: '#FFD700',
                },
              },
            }}
          >
            {tournaments.map((tournament, index) => (
              <Tab key={index} label={`${tournament.name} ${tournament.year}`} />
            ))}
          </Tabs>
        </Container>
      </Box>

      {/* Tab Content */}
      {activeTab === 0 && renderComingSoonContent('Himalayan Cup 2026')}
      {activeTab === 1 && renderComingSoonContent('Gurkha Cup 2026')}
      {activeTab === 2 && renderComingSoonContent('Gaule Cup 2026')}
      {activeTab === 3 && renderComingSoonContent('MAMC 2026')}
    </>
  );
};

export default Tournaments;
